export default {
  state: {
    getCountriesInCurrentCoverage: [],
    getCountriesCoverage: [],
    getRatesByCarrierService: [],
    getServicesByCountryCarrier: [],
    getServicesInCurrentCoveragesByCountryCarrier: [],
    deleteRate: [],
    getAdditionalCharges: [],
    getAdditionalChargesByRateId: [],
    getInternationalRatesByCarrierService: [],
    deleteInternationalRate: []
  },

  getters: {
    getCountriesInCurrentCoverage: state => state.getCountriesInCurrentCoverage,
    getCountriesCoverage: state => state.getCountriesCoverage,
    getRatesByCarrierService: state => state.getRatesByCarrierService,
    getServicesByCountryCarrier: state => state.getServicesByCountryCarrier,
    getServicesInCurrentCoveragesByCountryCarrier: (state) => state.getServicesInCurrentCoveragesByCountryCarrier,
    deleteRate: state => state.deleteRate,
    getAdditionalCharges: state => state.getAdditionalCharges,
    getAdditionalChargesByRateId: state => state.getAdditionalChargesByRateId,
    getInternationalRatesByCarrierService: state => state.getInternationalRatesByCarrierService,
    deleteInternationalRate: state => state.deleteInternationalRate
  },

  mutations: {
    setCountriesInCurrentCoverage(state, val) {
      state.getCountriesInCurrentCoverage = {
        rows: val.rows.map(el => ({...el, text: el.name}))
      }
    },
    setCountriesCoverage(state, val) {
      state.getCountriesCoverage = {
        rows: val.rows.map(el => ({...el, text: el.name}))
      }
    },
    setRatesByCarrierService(state, val) {
      if (val) {
        state.getRatesByCarrierService = {
          rows: val.data
        }
      } else {
        state.getRatesByCarrierService = {
          rows: []
        }
      }
    },
    setServicesByCountryCarrier(state, val) {
      if (val) {
        state.getServicesByCountryCarrier = {
          rows: val.data.map(el => ({...el, text: el.name}))
        }
      } else {
        state.getServicesByCountryCarrier = {
          rows: []
        }
      }
    },
    setServicesInCurrentCoveragesByCountryCarrier(state, val) {
      if (val) {
        state.getServicesInCurrentCoveragesByCountryCarrier = {
          rows: val.data.map((el) => ({ ...el, text: el.name }))
        }
      } else {
        state.getServicesInCurrentCoveragesByCountryCarrier = {
          rows: []
        }
      }
    },
    setDeleteRate(state, val) {
      state.deleteRate = val
    },
    setAdditionalCharges(state, val) {
      state.getAdditionalCharges = {
        rows: val.rows.map(el => ({...el, text: el.name})),
        meta: val.meta
      }
    },
    setAdditionalChargesByRateId(state, val) {
      state.getAdditionalChargesByRateId = {
        rows: val.rows.map(el => ({...el, text: el.name})),
        meta: val.meta
      }
    },
    setInternationalRatesByCarrierService(state, val) {
      state.getInternationalRatesByCarrierService = {
        rows: val.data
      }
    },
    setDeleteInternationalRate(state, val) {
      state.deleteInternationalRate = val
    }
  }
}

